import Card from "@/components/Card/Card.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
  faWhatsapp,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import {
  faAd,
  faArrowLeft,
  faBarcode,
  faBriefcase,
  faCalendarCheck,
  faChevronDown,
  faCircleNotch,
  faCircle,
  faComment,
  faComments,
  faEdit,
  faEnvelopeSquare,
  faEye,
  faFileContract,
  faFileExport,
  faGlobeAmericas,
  faHashtag,
  faHeart,
  faIcons,
  faImages,
  faInfo,
  faInfoCircle,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMousePointer,
  faNewspaper,
  faPercent,
  faPhoneAlt,
  faPlay,
  faSearch,
  faShare,
  faSignature,
  faUser,
  faUserCheck,
  faUserCog,
  faUserPlus,
  faUserSecret,
  faExclamationTriangle,
  faTimes,
  faCheckCircle,
  faStepForward,
  faDollarSign,
  faVideo,
  faThumbsUp,
  faBullseye,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/es";
import "element-ui/lib/theme-chalk/index.css";
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
import Lightbox from "vue-easy-lightbox";
import VueGallerySlideshow from "vue-gallery-slideshow";
import { GChart } from "vue-google-charts";
import VueMq from "vue-mq";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueHtmlToPaper from "vue-html-to-paper";
import { EventBus } from "./event-bus";
import VModal from "vue-js-modal";

library.add(
  faBullseye,
  faThumbsUp,
  faVideo,
  faUserSecret,
  faUser,
  faUserPlus,
  faSearch,
  faEye,
  faMousePointer,
  faFileContract,
  faUserCog,
  faBriefcase,
  faCircle,
  faUserCheck,
  faArrowLeft,
  faStepForward,
  faPhoneAlt,
  faMapMarkedAlt,
  faWhatsapp,
  faPlay,
  faGlobeAmericas,
  faEdit,
  faFileExport,
  faChevronDown,
  faPercent,
  faHashtag,
  faBarcode,
  faSignature,
  faShare,
  faNewspaper,
  faMapMarkerAlt,
  faInfoCircle,
  faInfo,
  faImages,
  faIcons,
  faHeart,
  faEnvelopeSquare,
  faComments,
  faComment,
  faCircleNotch,
  faCalendarCheck,
  faAd,
  faYoutube,
  faTwitter,
  faLinkedin,
  faInstagram,
  faFacebook,
  faExclamationTriangle,
  faTimes,
  faCheckCircle,
  faDollarSign
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("Card", Card);
Vue.component("VueGallerySlideshow", VueGallerySlideshow);
Vue.use(ElementUI, {
  locale
});

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "http://yodadashboard.azurewebsites.net/css/chunk-vendors.d9890480.css",
    "http://yodadashboard.azurewebsites.net/css/app.c635ee48.css"
  ]
};

Vue.use(VueHtmlToPaper, options);

Vue.use(VueGallerySlideshow);
Vue.component("GChart", GChart);
Vue.use(Lightbox);
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 768,
    smallLaptop: 992,
    laptop: 1024,
    desktop: Infinity
  }
});
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VModal);

Vue.config.productionTip = false;

const token = localStorage.getItem("user-token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}
axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent

    if (
      !axios.defaults.headers.common["Authorization"] ||
      (axios.defaults.headers.common["Authorization"] &&
        axios.defaults.headers.common["Authorization"].length == 0)
    ) {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("user-token")}`;
    }

    EventBus.$emit("loading", true);

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    EventBus.$emit("loading", false);
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      try {
        localStorage.removeItem("user-token");
        localStorage.removeItem("token-expiration");
      } catch (error) {
        console.log(
          "SE002 - Ops! Something happened while deleting the old cache data session."
        );
      }

      router.push({ path: "/" });
    }

    EventBus.$emit("loading", false);
    // Do something with response error
    return Promise.reject(error);
  }
);

Vue.use({
  install(Vue) {
    Vue.prototype.$axios = axios.create({
      baseURL: process.env.VUE_APP_API_BASE_URL
    });
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
